<template>
  <v-container class="py-8 bg-light-blue-main">
    <div class="mb-10">
      <v-card>
        <v-card-title>{{ $t("views.profile.profile") }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="first_name"
                label="Vorname"
                style="margin-bottom: 10px" />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="last_name"
                label="Nachname"
                style="margin-bottom: 10px" />
            </v-col>
            <v-col cols="6">
              <v-text-field
                value="*************"
                readonly
                class="no-pointer" />
            </v-col>
            <v-col cols="6">
              <v-btn @click="dialogChangePassword = true">{{
                $t("views.profile.changePassword")
              }}</v-btn>
              <v-dialog v-model="dialogChangePassword">
                <v-card>
                  <v-card-title>{{
                    $t("views.profile.changePassword")
                  }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="oldPassword"
                      label="Altes Passwort"
                      type="password"
                      style="margin-bottom: 10px" />
                    <v-text-field
                      v-model="newPassword"
                      label="Neues Passwort"
                      type="password"
                      style="margin-bottom: 10px" />
                    <v-text-field
                      v-model="confirmPassword"
                      label="Passwort bestätigen"
                      type="password"
                      style="margin-bottom: 10px" />
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="changePassword(false)">{{
                      $t("views.profile.cancel")
                    }}</v-btn>
                    <v-btn @click="changePassword(true)">{{
                      $t("views.profile.save")
                    }}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <DeleteWithConfirmationButton
            message="delete-user"
            class="mr-5"
            :deleteAction="authStore.deleteAccount" />

          <v-btn @click="changeName">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </div>
    <h1 class="mb-5">Lizenzen</h1>
    <v-row>
      <v-col>
        <v-card
          width="400"
          height="400px">
          <v-card-title>Private Lizenz</v-card-title>
          <v-card-text>
            <span>Monatliche Kosten: {{ personalLicence.price }}€</span>
            <br />
            Module
            <ul>
              <template v-for="module in MODULES">
                <li v-if="module.id & personalLicence.modules">
                  {{ module.module }}
                </li></template
              >
            </ul>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn @click="router.push({ name: 'licence-private' })">
              Bearbeiten
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col v-for="groupLicence in groupLicences">
        <v-card
          width="400px"
          height="400px">
          <v-card-title>Gruppen Lizenz: {{ groupLicence.name }}</v-card-title>
          <v-card-text>
            Monatliche Kosten: {{ groupLicence.price }}€ (TODO) Gewählte Module:
            ...
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="
                router.push({
                  name: 'licence-group',
                  params: { id: groupLicence.id }
                })
              ">
              Bearbeiten
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card
          width="400px"
          height="400px"
          @click="router.push({ name: 'licence-group-create' })">
          Neue Gruppen-Lizenz erstellen
        </v-card>
      </v-col>
    </v-row>
    <h1>Organizationen</h1>
    <v-row>
      <v-col v-for="organization in mainStore.organizations">
        <v-card data-cy="organization-card">
          <v-card-title>{{ organization.organization.name }}</v-card-title>
          <v-card-subtitle>{{
            organization.organization.name
          }}</v-card-subtitle>
          <v-card-actions v-if="organization.state === 0">
            <v-btn
              @click.stop="
                declineOrganizationInvite(organization.organization.id)
              "
              >Ablehnen</v-btn
            >
            <v-btn
              @click.stop="
                acceptOrganizationInvite(organization.organization.id)
              "
              >Annehmen</v-btn
            >
          </v-card-actions>
          <v-card-actions
            v-else-if="
              mainStore.organizationRights(organization.organization.id) &
              (ORGANIZATION_RIGHT_OWNER | ORGANIZATION_RIGHT_COOWNER)
            ">
            <v-btn @click.stop="editOrganization(organization.organization.id)"
              >Bearbeiten</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col>
        <v-btn
          data-cy="create-organization"
          @click="router.push({ name: 'organization-create' })"
          >Organization erstellen</v-btn
        >
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts" setup>
import { onMounted } from "vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useSnackbar } from "vuetify-use-dialog";
import { useTranslation } from "i18next-vue";
import { useAuthStore } from "@/stores/authStore";
import axios from "axios";
import {
  MODULES,
  ORGANIZATION_RIGHT_COOWNER,
  ORGANIZATION_RIGHT_OWNER
} from "@/utils/constants";
import DeleteWithConfirmationButton from "@/components/tools/DeleteWithConfirmationButton.vue";
import { useMainStore } from "@/stores/mainStore";
// import { organization } from "@/types/global";

const { t } = useTranslation();
const createSnackbar = useSnackbar();
const personalLicence = ref({});
const groupLicences = ref([]);

const router = useRouter();

const emit = defineEmits(["close"]);

const authStore = useAuthStore();
const mainStore = useMainStore();

const first_name = ref("");
const last_name = ref("");

onMounted(() => {
  first_name.value = authStore.user.first_name;
  last_name.value = authStore.user.last_name;
});

function changeName() {
  authStore.changeUserName(first_name.value, last_name.value);
  createSnackbar({
    text: t("actions.success.name"),
    showCloseButton: false,
    snackbarProps: { color: "success", timeout: 1000 }
  });
}

const dialogChangePassword = ref(false);
const oldPassword = ref("");
const newPassword = ref("");
const confirmPassword = ref("");

function editOrganization(id: number) {
  // edit organization
  router.push({ name: "organization", params: { id: id } });
}

function changePassword(accept: boolean) {
  if (!accept) {
    dialogChangePassword.value = false;
    return;
  }

  authStore
    .changePassword(oldPassword.value, newPassword.value, confirmPassword.value)
    .then((response) => {
      console.log("changePasswordSuccess", response);
      dialogChangePassword.value = false;
      createSnackbar({
        text: t("actions.success.password-changed"),
        showCloseButton: false,
        snackbarProps: { color: "success", timeout: 1000 }
      });
    })
    .catch((error) => {
      createSnackbar({
        text: t("responses." + error.response.data),
        showCloseButton: false,
        snackbarProps: { color: "error", timeout: 1000 }
      });
      console.error(error);
    });
}

function loadLicenses() {
  // load licenses
  axios.get("/api/licence/private").then((response) => {
    console.log(response.data);

    personalLicence.value = {
      modules: response.data.allModules,
      monthEnd: response.data.removedModules,
      price:
        Object.values(MODULES).reduce(
          (acc, module) =>
            acc + (module.id & response.data.modules ? module.price : 0),
          0
        ) / 100
    };
  });
}

function acceptOrganizationInvite(organizationId: number) {
  mainStore.acceptOrganizationInvitation(
    organizationId,
    mainStore.loadOrganizations
  );
}

function declineOrganizationInvite(organizationId: number) {
  mainStore.declineOrganizationInvitation(organizationId).then(() => {
    mainStore.loadOrganizations();
  });
}

onMounted(() => {
  loadLicenses();
});
</script>
